import React, { useState } from 'react';
import { FaPhoneAlt, FaTimes, FaCalendarAlt, FaCheckCircle } from 'react-icons/fa';

const ContactProcessModal = ({ onClose }) => {
  return (
    <div className="contact-modal-overlay">
      <div className="contact-modal-content bg-amber-400 text-black">
        <button onClick={onClose} className="contact-modal-close-button text-slate-950">
          <FaTimes />
        </button>
        
        <h2 className="text-3xl font-bold text-black text-center mb-10">CONTACT PROCESS</h2>
        <div className="flex justify-between items-start flex-nowrap space-x-4">
          
          <div className="flex flex-col items-center text-center relative process-item">
            <div className="w-16 h-16 rounded-full bg-slate-950 border-2 border-slate-950 text-black flex items-center justify-center mb-4">
              <FaPhoneAlt size={24} />
            </div>
            <h3 className="text-xl font-bold text-black mb-2">1. Share Your Requirements</h3>
            <p className="text-black text-sm">
              Reach us through the service inquiry form & tell us what you are looking for. Make sure you check the filled details.
            </p>
          </div>
          
          {/* Connecting line segment */}
          <div className="process-line-segment"></div>

          <div className="flex flex-col items-center text-center relative process-item">
            <div className="w-16 h-16 rounded-full bg-slate-950 border-2 border-slate-950 text-black flex items-center justify-center mb-4">
              <FaCalendarAlt size={24} />
            </div>
            <h3 className="text-xl font-bold text-black mb-2">2. Schedule A Consultation</h3>
            <p className="text-black text-sm">
              If needed, you might have to bring your car in for a physical inspection. If not, then you shall receive a detailed estimate via mail.
            </p>
          </div>

          {/* Connecting line segment */}
          <div className="process-line-segment"></div>

          <div className="flex flex-col items-center text-center relative process-item">
            <div className="w-16 h-16 rounded-full bg-slate-950 border-2 border-slate-950 text-amber-400 flex items-center justify-center mb-4">
              <span className="text-2xl font-bold text-black">i</span>
            </div>
            <h3 className="text-xl font-bold text-black mb-2">3. Book An Appointment</h3>
            <p className="text-black text-sm">
              Wish to proceed ahead? Then pay a small refundable token and fix the latest available date. We work on appointments only.
            </p>
          </div>

          {/* Connecting line segment */}
          <div className="process-line-segment"></div>

          <div className="flex flex-col items-center text-center relative process-item">
            <div className="w-16 h-16 rounded-full bg-slate-950 border-2 border-slate-950 text-black flex items-center justify-center mb-4">
              <FaCheckCircle size={24} />
            </div>
            <h3 className="text-xl font-bold text-black mb-2">4. Bring Your Car In For Work</h3>
            <p className="text-black text-sm">
              Your appointment date has arrived? Simply walk in with your car and our advisor will take care of the rest.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const ContactButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <button 
        className="fixed bottom-8 right-8 z-50 bg-amber-400 text-slate-950 p-4 rounded-full shadow-lg transition duration-300 hover:scale-110"
        onClick={toggleModal}
      >
        <FaPhoneAlt size={24} />
      </button>

      {isOpen && <ContactProcessModal onClose={toggleModal} />}
    </>
  );
};

export default ContactButton;